import { FunctionComponent } from "react";
import { Car } from "../../services/mobile";
import Paragraph from "../../styles/Paragraph";

interface Props {
  car: Car;
}

const CarFeatures: FunctionComponent<Props> = ({ car }) => {
  const features: string[] = [];
  if (car.specifics["construction-year"]) {
    features.push(`Bouwjaar ${car.specifics["construction-year"]}`);
  }
  if (car.specifics.mileage) {
    const km = new Intl.NumberFormat("nl-NL", {
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
    }).format(parseInt(car.specifics.mileage));
    features.push(`Kilometerstand: ${km} km`);
  }
  if (car.specifics.fuel) {
    features.push(`brandstof: ${car.specifics.fuel}`);
  }

  return <Paragraph>{features.join(", ")}</Paragraph>;
};

export default CarFeatures;
